<template>
  <v-dialog persistent scrollable v-model="dialog" max-width="1000">
    <v-card>
      <v-card-title class="py-4 px-2" v-if="lead != null">
        <v-toolbar
          color="white"
          class="my-referral-details-toolbar__content"
          style="height: 56px"
          flat
        >
          <v-toolbar-title v-if="!loading && !loadingError">
            <v-row class="align-center">
              <v-col class="px-3" style="max-width: 58px">
                <v-avatar size="large" :color="iconColor">
                  <span class="text-white text-h5">{{ iconText }}</span>
                </v-avatar>
              </v-col>
              <v-col class="px-5">
                <v-row>
                  <v-col class="headline pl-3">
                    {{ displayName }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="close">
            <v-icon style="color: black">fas fa-times</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-title v-else class="pa-4">
        <v-row class="align-center">
          <v-col cols="11" class="headline"> Lead </v-col>
          <v-spacer />
          <v-col cols="1" class="pr-2 text-right">
            <v-btn icon @click="close">
              <v-icon color="black">fas fa-times</v-icon>
            </v-btn></v-col
          >
        </v-row>
      </v-card-title>
      <v-divider />

      <v-card-text id="agent-referral-details" style="height: 500px">
        <v-row v-if="loading" class="align-center justify-center">
          <v-col class="mt-8">
            <div style="width: 100%; min-height: 420px">
              <v-row class="align-center justify-center">
                <v-progress-circular
                  :size="75"
                  :width="8"
                  color="primary"
                  indeterminate
                />
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-list v-else-if="!loading && !loadingError">
          <my-lead-detail-details :lead="lead" />
        </v-list>
        <v-row v-else class="align-center justify-center">
          <dialog-error message="An error occurred loading this referral." />
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/services/api.js";
import MyLeadDetailDetails from "@/components/console/my-leads/MyLeadDetailDetails";
import useAuthMixin from "@/mixins/auth.js";
import useFormatters from "@/mixins/formatters";
import { defineAsyncComponent } from "vue";

export default {
  name: "MyLeadDetails",
  components: {
    MyLeadDetailDetails,
    DialogError: defineAsyncComponent(
      () => import("@/components/console/dialog/DialogError"),
    ),
  },
  props: {
    opportunityId: {
      type: String,
      default: null,
    },
    parent: {
      type: String,
      default: "agents",
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingError: false,
      lead: null,
      subData: [],
    };
  },
  computed: {
    iconColor() {
      return "primary";
    },
    iconText() {
      if (this.lead) {
        let ln = this.leadName(this.lead);

        if (ln.trim() !== "") {
          return ln.charAt(0).toUpperCase();
        }
      }

      return "-";
    },
    displayName() {
      if (this.lead) {
        let ln = this.leadName(this.lead);

        if (ln.trim() !== "") {
          return ln.trim();
        }
      }

      return "Unavailable";
    },
  },
  methods: {
    ...useAuthMixin(),
    ...useFormatters(),
    async loadLead() {
      this.loading = true;
      this.loadingError = false;

      try {
        let { data } = await api.interviews.getLead(this.opportunityId);
        this.lead = data;
      } catch (e) {
        this.errorCheck(e);
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;

      if (this.parent !== "") {
        this.$router.back();
      } else {
        this.$emit("closed");
      }
    },
  },
  mounted() {
    this.dialog = true;
    this.loadLead();
  },
};
</script>

<style scoped>
.my-referral-details-toolbar__content >>> .v-toolbar__content {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
</style>
